












































/* eslint-disable */
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from "@/common/config";


import { Component, Vue, Mixins } from "vue-property-decorator";
import PageInitialMixin from "@/mixins/PageInitialMixin";
import { Getter, Action } from "vuex-class";
import TimeSection from './TimeSection.vue';

@Component({
  components: {
    "time-section": TimeSection
  },
})
export default class Profile extends Vue {

  @Getter("isInvalid") isInvalid: any;
  @Getter("isAgain") isAgain!: string;
  @Getter("contactQrcode") contactQrcode!: string;
  @Getter("title") title!: string;
  @Getter("instName") instName!: string;
  @Getter("deadline") deadline!: any;
  @Getter("startTime") startTime!: any;
  @Getter("activityRule") activityRule!: string;
  @Getter("instAddress") instAddress!: string;
  @Getter("instPhone") instPhone!: string;
  @Getter("institutionIntros") institutionIntros!: Array<object>;
  @Action("changeShowFooter") changeShowFooter!: Function;
  @Getter("joinNumber") joinNumber!: number;
  @Getter("scanNumber") scanNumber!: number;
  get callPhone(): string {
    return "tel:" + this.instPhone;
  }
  isCopy: boolean = false;
  isFromDistribute: boolean = true;
  message: object = {};
  hidden: boolean = false;
  activityStatus:string="noStart";
  type: string = getUrlParam("type") as string;
  interval: any = {};
  created() {
    const isCopy = getUrlParam('state') == 'copy';
    this.isCopy = isCopy;
  }
  mounted() {
    this.interval = setInterval(()=>{
      this.getActivityStatus();
    },1000)
  }
  hiddenKeyboard(evt: Event): void {
    (document.activeElement as HTMLElement).blur();
  }
  getActivityStatus(){
    console.log(this.deadline,this.startTime)
    const activityDeadline: number = this.deadline;
    const activityStartTime: number = this.startTime;
    const nowTimestamp: number = new Date().valueOf();
    if(activityStartTime > nowTimestamp){
      this.activityStatus = "noStart"
    }else{
      if(nowTimestamp<activityDeadline){
        this.activityStatus = "startIng";
      }else{
        this.activityStatus = "endIng";
      }
    }
  }
  goNext():void {
    console.log(this.activityStatus)
    if(this.isInvalid) {
      Vue.$toast.error("活动已失效");
    }else {
      if(this.activityStatus=='startIng') {
        if (window.TDAPP) {
          window.TDAPP.onEvent("首页点击开始测评", "小程序", {
          });
        }
        let url = `/pages/ask-info/index?openid=${this.$store.state.openId}`
        console.log('redirect', url);
        window.wx.miniProgram.navigateTo({
            url,
        });
      }else if(this.activityStatus=='noStart') {
        Vue.$toast.error("活动未开始");
      }else if(this.activityStatus=='endIng') {
        Vue.$toast.error("活动已结束");
      }
    }
  }
  gosee():void {
    let url = `/pages/short-result/index?openid=${this.$store.state.openId}&activityId=${getUrlParam('broadcastId')}`
    console.log('redirect', url);
    window.wx.miniProgram.navigateTo({
        url,
    });
  }

  destroyed(){
    clearInterval(this.interval)
  }
}
